import RIOSwitch, { type SwitchProps } from '@rio-cloud/rio-uikit/Switch';

const Switch = (props: SwitchProps) => <RIOSwitch {...props} />;

export default Switch;
